class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', {bubbles: true});

		this.querySelectorAll('button').forEach((button) =>
			button.addEventListener('click', this.onButtonClick.bind(this)),
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value)
			this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define('quantity-input', QuantityInput);

/*
 * Shopify Common JS
 *
 */

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: `application/${type}`,
		},
	};
}

if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (let i = 0, count = selector.options.length; i < count; i++) {
		let option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	let method = options['method'] || 'post';
	let params = options['parameters'] || {};

	let form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (let key in params) {
		let hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector('[type="button"]');

		if (!button) return;
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'));
			if (modal) modal.show(button);
		});
	}
}
customElements.define('modal-opener', ModalOpener);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', this.onVariantChange);
	}

	onVariantChange() {
		this.updateOptions();
		this.updateVariantStatuses();
		this.updateSelectedValueLabels();
		this.updateMasterId();
		this.toggleAddButton('', !this.currentVariant);
		this.toggleCustomizerButton();
		this.toggleBackInStock();
		this.removeErrorMessage();

		if (!this.currentVariant) {
			this.setUnavailable();
		} else {
			this.updateMedia();
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
		}
	}

	updateOptions() {
		this.options = Array.from(
			this.querySelectorAll('select'),
			(select) => select.value,
		);
	}

	updateSelectedValueLabels() {
		this.querySelectorAll('fieldset').forEach((fieldset) => {
			const checked = fieldset.querySelector('input:checked');
			const valueLabel = fieldset.querySelector('[data-js-selected-value]');
			if (checked && valueLabel) valueLabel.textContent = checked.value;
		});
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
	}

	toggleCustomizerButton() {
		const buttons = document.querySelectorAll(
			'[data-pw-customizer-open], [data-pw-sticky-customize-btn]',
		);
		const isUnavailable = !this.isVariantInStock(this.currentVariant);

		buttons.forEach((button) => {
			button.toggleAttribute('hidden', isUnavailable);
		});
	}

	updateMedia() {
		if (!this.currentVariant) return;
		if (!this.currentVariant.featured_media) return;

		// This theme has no MediaGallery element; guard to avoid breaking the change handler
		const mediaGallery = document.getElementById(
			`MediaGallery-${this.dataset.section}`,
		);
		if (!mediaGallery) return;
		mediaGallery.setActiveMedia(
			`${this.dataset.section}-${this.currentVariant.featured_media.id}`,
			true,
		);

		const modalContent = document.querySelector(
			`#ProductModal-${this.dataset.section} .product-media-modal__content`,
		);
		if (!modalContent) return;
		const newMediaModal = modalContent.querySelector(
			`[data-media-id="${this.currentVariant.featured_media.id}"]`,
		);
		modalContent.prepend(newMediaModal);
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
		window.history.replaceState(
			{},
			'',
			`${this.dataset.url}?variant=${this.currentVariant.id}`,
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', {bubbles: true}));
		});
	}

	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}

	renderProductInfo() {
		fetch(
			`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
		)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				const sourceSectionId = this.dataset.originalSection
					? this.dataset.originalSection
					: this.dataset.section;
				const destination = document.getElementById(
					`price-${this.dataset.section}`,
				);
				const source = html.getElementById(`price-${sourceSectionId}`);
				this.updateSourceFromDestination(html, 'price');
				if (source && destination) destination.innerHTML = source.innerHTML;

				// Re-render the media gallery so variant-specific images (clrz.variant_images) update
				const mediaDestination = document.getElementById(
					`product-media-${this.dataset.section}`,
				);
				const mediaSource = html.getElementById(
					`product-media-${sourceSectionId}`,
				);
				if (mediaSource && mediaDestination) {
					mediaDestination.innerHTML = mediaSource.innerHTML;
					// Ask the islands loader to hydrate the new content (mobile slider, zoom modal)
					document.dispatchEvent(
						new CustomEvent('islands:revive', {
							detail: {container: mediaDestination},
						}),
					);
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove('visibility-hidden');
				this.toggleAddButton(
					window.variantStrings.soldOut,
					!this.isCurrentVariantPurchasable(),
				);
			});
	}

	isCurrentVariantPurchasable() {
		if (!this.isVariantInStock(this.currentVariant)) return false;

		const productForm = document
			.getElementById(`product-form-${this.dataset.section}`)
			?.closest('product-form');
		if (!productForm?.hasDefaultContentAvailable) return true;

		return productForm.hasDefaultContentAvailable(this.currentVariant.id);
	}

	updateSourceFromDestination(html, id, shouldHide = (source) => false) {
		const source = html.getElementById(`${id}-${this.sectionId}`);
		const destination = this.querySelector(`#${id}-${this.dataset.section}`);
		if (source && destination) {
			destination.innerHTML = source.innerHTML;
			destination.classList.toggle('hidden', shouldHide(source));
		}
	}

	toggleBackInStock() {
		const isSoldOut =
			Boolean(this.currentVariant) && !this.isVariantInStock(this.currentVariant);

		document.querySelectorAll('klaviyo-back-in-stock').forEach((el) => {
			el.classList.toggle('hidden', !isSoldOut);
			if (!this.currentVariant) return;
			el.dataset.variantId = this.currentVariant.id;
		});

		document
			.querySelectorAll('[data-js-product-atc], [data-js-sticky-atc]')
			.forEach((el) => {
				el.classList.toggle('hidden', isSoldOut);
			});
	}

	toggleAddButton(text, disable = true) {
		const productForm = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}
	}

	setUnavailable() {
		const button = document.getElementById(
			`product-form-${this.dataset.section}`,
		);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add('visibility-hidden');
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	getVariantStockMap() {
		if (this.variantStockMap) return this.variantStockMap;
		const stockScript = this.querySelector('[data-variant-stock]');
		this.variantStockMap = stockScript
			? JSON.parse(stockScript.textContent)
			: {};
		return this.variantStockMap;
	}

	isVariantInStock(variant) {
		if (!variant || !variant.available) return false;
		return this.getVariantStockMap()[variant.id] !== false;
	}
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
	constructor() {
		super();
	}

	updateOptions() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'));
		this.options = fieldsets.map((fieldset) => {
			return Array.from(fieldset.querySelectorAll('input')).find(
				(radio) => radio.checked,
			).value;
		});
	}

	updateVariantStatuses() {
		const fieldsets = Array.from(this.querySelectorAll('fieldset'));
		const variants = this.getVariantData();

		fieldsets.forEach((fieldset, optionIndex) => {
			Array.from(fieldset.querySelectorAll('input')).forEach((input) => {
				const isAvailable = variants.some((variant) => {
					if (!this.isVariantInStock(variant)) return false;

					return variant.options.every((optionValue, variantOptionIndex) => {
						if (variantOptionIndex === optionIndex) {
							return optionValue === input.value;
						}

						return this.options[variantOptionIndex] === optionValue;
					});
				});

				this.updateVariantInputState(input, isAvailable);
			});
		});
	}

	updateVariantInputState(input, isAvailable) {
		const label = this.querySelector(`[for="${input.id}"]`);
		if (!label) return;

		input.dataset.pwVariantOption = isAvailable ? 'active' : 'disabled';
		input.removeAttribute('aria-disabled');

		label.classList.toggle('disabled', !isAvailable);
		label.classList.add('u-cursor-pointer');
		label.setAttribute('tabindex', '0');
	}
}

customElements.define('variant-radios', VariantRadios);

class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector(
				'input[name="language_code"], input[name="country_code"]',
			),
			button: this.querySelector('button'),
			panel: this.querySelector('ul'),
		};
		this.elements.button.addEventListener(
			'click',
			this.openSelector.bind(this),
		);
		this.elements.button.addEventListener(
			'focusout',
			this.closeSelector.bind(this),
		);
		this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

		this.querySelectorAll('a').forEach((item) =>
			item.addEventListener('click', this.onItemClick.bind(this)),
		);
	}

	hidePanel() {
		this.elements.button.setAttribute('aria-expanded', 'false');
		this.elements.panel.setAttribute('hidden', true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		this.hidePanel();
		this.elements.button.focus();
	}

	onItemClick(event) {
		event.preventDefault();
		const form = this.querySelector('form');
		this.elements.input.value = event.currentTarget.dataset.value;
		if (form) form.submit();
	}

	openSelector() {
		this.elements.button.focus();
		this.elements.panel.toggleAttribute('hidden');
		this.elements.button.setAttribute(
			'aria-expanded',
			(
				this.elements.button.getAttribute('aria-expanded') === 'false'
			).toString(),
		);
	}

	closeSelector(event) {
		const shouldClose =
			event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
		if (event.relatedTarget === null || shouldClose) {
			this.hidePanel();
		}
	}
}

customElements.define('localization-form', LocalizationForm);
